import styled from "styled-components";
import Button from "react-bootstrap/Button";

export const Wrapper = styled.div`
  position: absolute;
  top:40px;
  right: 0;
  padding: 20px;
  width: 268px;
  height: 226px;
  background: radial-gradient(100% 100% at 0% 0%, rgb(220,220,221), rgb(250,250,251));
  box-shadow: 8.5px 8.5px 8.5px rgba(158, 158, 158, 0.33);
  z-index: 10000;
  border-radius: 10px;
`

export const Close = styled.div`
  background: radial-gradient(100% 100% at 0% 0%, rgba(221, 227, 250, 0.99) 0%, rgba(221, 229, 250, 0.4) 100%);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  width: 24px;
  position: absolute;
  top: -15px;
  right: -10px;
  border-radius: 100%;
  cursor: pointer;
`;

export const Textarea = styled.textarea`
  color: #000;
  background: rgba(255, 255, 255, 1);
  border-radius: 6px;
  resize: none;
  padding: 8px 12px;
  border: 1px solid rgb(180, 202, 236);
  width: 100%;
  font-size: 14px;
  height: 70px;
  margin: 18px 0;
  &:focus{
    box-shadow: none;
    background: rgba(255, 255, 255, 0.3);
    color: #000;
    outline: none;
  }
`
export const StyledParagraph = styled.p`
font-family: NunitoSans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 10px;
line-height: 156%;
letter-spacing: 0.01em;
color: #2C2B48;
`;

export const StyledBtn = styled(Button)`
width: 80px;
height: 30px;
background: rgba(103, 156, 239, 0.8);
border-radius: 8px;
border-width: 0;
font-size: 10px;
display: flex;
justify-content: center;
align-items: center;
margin: 0 auto;
&:hover{
  background: rgba(103, 156, 239, 0.8);
  box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
  border-radius: 8px;
  border-width: 0;
}
&:focus{
  border-width: 0;
  background: rgba(103, 156, 239, 0.8);
  box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
}
`;

export const Img = styled.img``;